import layout from '@/layouts/link-block.vue'
import importAllImages from '@/functions/importAllImages.js'

// import IconSpeakerPodium from '@/components/icons/icon-speaker-podium.vue'
// import IconSpeechbubble from '@/components/icons/icon-speechbubble.vue'
import IconShoppingcartAdd from '@/components/icons/icon-shoppingcart-add.vue'
import book from '@/content/project/book.png'


export default {
  version: '1.1.5',
  layout,
  showDump: false,
  custom: {},
  analytics: { id: 'UA-139327500-5' },

  // !! WARNING !!
  // This function imports all images, regardless of whether they are used or not
  // be sure to move unused images to a different location
  allImages: importAllImages(require.context('../images', false, /\.js/)),

  header: {
    title: 'LAWYER X',
    intro: [
      'Dive deep into Australia\'s biggest criminal justice scandal',
      'By the journalists who broke the story and covered it every step of the way.',
    ],
    image: {
      src: 'background',
      alt: '',
    },
    book,
  },

  social: '',

  parts: [
    {
      type: 'book',
      title: 'Pre-order the paperback',
      subtitle: '',
      link: 'https://www.booktopia.com.au/lawyer-x-anthony-dowsley/prod9781460758069.html',
      icon: IconShoppingcartAdd,
    },
    {
      type: 'ebook',
      title: 'Pre-order the e-book',
      subtitle: 'Apple iBooks',
      link: 'https://books.apple.com/au/book/lawyer-x/id1465294481',
      icon: IconShoppingcartAdd,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/content/project/index.js